import { AdviseCurrentSupplier } from '../../../../types/advise';
import { useEngagementEditor } from './EngagementEditorContext';
import { CurrentSupplierCard } from './CurrentSupplierCard';

export interface OpenSupplierEntry {
  supplierId: string;
  invoiceId: string | null;
}

const NOTHING_TO_SAVE = Promise.resolve(null);

export interface CurrentSupplierCardsProps {
  suppliers: AdviseCurrentSupplier[];
  onOpen: (entry: OpenSupplierEntry) => void;
  onAdd: () => void;
}

/** A card per current supplier, then the dashed row that adds another. */
export const CurrentSupplierCards = ({ suppliers, onOpen, onAdd }: CurrentSupplierCardsProps) => {
  const { canEdit, currentSuppliers } = useEngagementEditor();
  return (
    <>
      {suppliers.map((supplier) => (
        <CurrentSupplierCard
          key={supplier.id}
          supplier={supplier}
          canEdit={canEdit}
          onOpen={(invoiceId) => onOpen({ supplierId: supplier.id, invoiceId })}
          onRemoveSupplier={() => currentSuppliers?.removeSupplier(supplier.id) ?? NOTHING_TO_SAVE}
          onUploadInvoice={(file) => currentSuppliers?.uploadInvoice(supplier.id, file) ?? NOTHING_TO_SAVE}
          onRemoveInvoice={(invoiceId) => currentSuppliers?.removeInvoice(supplier.id, invoiceId) ?? NOTHING_TO_SAVE}
        />
      ))}
      {canEdit && suppliers.length > 0 && (
        <button
          type="button"
          className="w-full rounded-lg border border-dashed border-grey-3 px-4 py-3 text-sm font-medium text-main-100 hover:bg-grey-1"
          onClick={onAdd}>
          + Add Current Supplier
        </button>
      )}
    </>
  );
};
